const exportToCsv = (data, columns) => {
  let exportData = {
    data: [],
    headers: [],
  };
  data.forEach((row, index) => {
    let tempValueObj = {};

    // console.log(row);

    Object.keys(row).forEach((val, idx) => {
      let foundColumnForEachRowValue = columns.find((d) => {
        // console.log(val, d);
        return d.accessorKey === val;
      });

      if (foundColumnForEachRowValue && foundColumnForEachRowValue.csvExport) {
        if (foundColumnForEachRowValue.csvFormatter) {
          //csv formatter present
          // console.log(foundColumnForEachRowValue);
          tempValueObj[foundColumnForEachRowValue.header] = foundColumnForEachRowValue.csvFormatter(
            row[foundColumnForEachRowValue.accessorKey],
            row,
            data
          );
        } else {
          //no csv formatter
          tempValueObj[foundColumnForEachRowValue.header] = row[foundColumnForEachRowValue.accessorKey];
        }
      }
    });
    exportData.data.push(tempValueObj);
  });

  let headers = [];
  columns.forEach((val) => {
    if (val.csvExport) {
      headers.push(val.header);
    }
  });

  exportData.headers = headers;
  return exportData;
};

export default exportToCsv;
